// ROCCS Theme JS

document.addEventListener('DOMContentLoaded', function() {

  // ===== MOBILE MENU TOGGLE (hamburguesa) =====
  var toggle = document.querySelector('.header__mobile-toggle');
  var mobileNav = document.querySelector('#mobileNav');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      mobileNav.classList.toggle('open');
    });
  }

  // ===== MOBILE SUBMENU (desplegable en vertical) =====
  document.querySelectorAll('.header__mobile-parent').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var sub = btn.nextElementSibling;
      var isOpen = sub.classList.contains('open');
      document.querySelectorAll('.header__mobile-sub').forEach(function(s) {
        s.classList.remove('open');
      });
      document.querySelectorAll('.header__mobile-parent').forEach(function(b) {
        b.classList.remove('active');
      });
      if (!isOpen) {
        sub.classList.add('open');
        btn.classList.add('active');
      }
    });
  });

  // ===== CERRAR MENÚ AL TOCAR FUERA =====
  document.addEventListener('click', function(e) {
    if (mobileNav && toggle) {
      if (!mobileNav.contains(e.target) && !toggle.contains(e.target)) {
        mobileNav.classList.remove('open');
      }
    }
  });

  // ===== ADD TO CART =====
  document.querySelectorAll('.product-card__btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var productId = btn.dataset.productId;
      if (!productId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        btn.textContent = '¡Agregado!';
        btn.style.background = '#22c55e';
        setTimeout(function() {
          btn.textContent = 'Agregar al carrito';
          btn.style.background = '';
        }, 1500);
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) countEl.textContent = cart.item_count;
          });
      })
      .catch(function() {
        btn.textContent = 'Ver producto';
      });
    });
  });

});